import component from './Preloader.vue'
export default component
